
import gql from 'graphql-tag';
import Vue from 'vue';

interface Recipient {
  reference: string;
  account_id: string;
  name: string;
  legal_entity_by_reference?: {
    registration_name: string;
  };
  channel_endpoints: {
    endpoint: string;
    channel: string;
  }[];
}

const RECIPIENTS_WITH_ENDPOINTS = gql`
query componentsLinkRecipientDialog__recipients($participant: uuid!, $search: String!, $legal_entity: uuid) {
  recipients: risolto_recipient(
    where: {
      _and: [
        { participant: { _eq: $participant } }
        {
          _or: [
            { name: { _ilike: $search } },
            { account_id: { _ilike: $search } },
            { channel_endpoints: { 
              _and: [
                { endpoint: { _ilike: $search } }
                { contact: { _is_null: true } }
                { deactivated_at: { _is_null: true } }
              ]
            }},
			{
				contacts:
				{
					_or: [
						{
							first_name: {
								_ilike: $search
							}
						},
						{
							last_name: {
								_ilike: $search
							}
						},
						{
							full_name: {
								_ilike: $search
							}
						}
					]
				}
			}
          ]
        }
        {
          _or: [
            { legal_entity: { _eq: $legal_entity } }
            { legal_entity: { _is_null: true } }
          ]
        }
      ]
    }
    limit: 25
  ) {
    reference
    account_id
    name
    legal_entity_by_reference {
      registration_name
    }
    channel_endpoints(where: { 
      _and: [
        { contact: { _is_null: true } }
        { deactivated_at: { _is_null: true } }
      ]
    }) {
      endpoint
      channel
    }
  }
}
`;

export default Vue.extend({
	data() {
		return {
			visible: false,
			resolvePromise: undefined as ((value: any) => void) | undefined,
			rejectPromise: undefined as ((reason?: any) => void) | undefined,
			search: '',
			recipients: [] as Recipient[],
			selection: [] as Recipient[]
		};
	},
	methods: {
		show() {
			// Reset our state
			this.search = '';
			this.recipients = [];
			this.selection = [];
			// Once we set our config, we tell the popup modal to open
			this.visible = true;
			// Return promise so the caller can get results
			return new Promise((resolve, reject) => {
				this.resolvePromise = resolve;
				this.rejectPromise = reject;
			});
		},

		handleSelectionChange(selection: Recipient[]) {
			this.selection = selection;
		},

		handleSearch(): void {
			const participant = this.$store.state.risolto.selectedParticipantStore;
			const legal_entity = this.$store.state.risolto.selectedLegalEntityStore;
			const search = `%${this.search.trim()}%`;

			this.$apollo
				.query({
					query: RECIPIENTS_WITH_ENDPOINTS,
					variables: { participant, search, legal_entity }
				})
				.then(({ data }) => {
					this.recipients = data.recipients;
				})
				.catch((error) => {
					this.$message.error(error.message);
				});
		},

		handleLink(): void {
			const selection = Array.isArray(this.selection) ? this.selection : [];
			if (selection.length === 0) {
				this.$message.error('Please select a recipient');
				return;
			}

			const recipientReferences = selection.map((item) => item.reference);

			this.visible = false;
			this.resolvePromise(recipientReferences);
		},

		handleClose(): void {
			this.visible = false;
			if (this.resolvePromise) {
				this.resolvePromise([]);
			}
		}
	}
});
